<script setup lang="ts">
import { useLexicalComposer } from "lexical-vue";
import { watch } from "vue";

const props = defineProps<{
  editable: boolean;
  dontFocus?: boolean;
}>();

const editor = useLexicalComposer();

watch(
  () => props.editable,
  (newEditable) => {
    editor.setEditable(newEditable);
    if (newEditable && !props.dontFocus) {
      editor.focus();
    }
  }
);
</script>

<template>
  <slot />
</template>
